// extracted by mini-css-extract-plugin
export var divider = "_vl-0";